var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh"}},[(_vm.err !== '')?_c('not-found'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }